export const TYPES = {
  SET_PAYMENT_WITHDRAW_ALL: "payment_withdraw/SET_PAYMENT_WITHDRAW_ALL",
  //
  SET_PAYMENT_WITHDRAW_BANKS: "payment_withdraw/SET_PAYMENT_WITHDRAW_BANKS",
  SET_PAYMENT_WITHDRAW_CODE: "payment_withdraw/SET_PAYMENT_WITHDRAW_CODE",
  SET_PAYMENT_WITHDRAW_SEARCH: "payment_withdraw/SET_PAYMENT_WITHDRAW_SEARCH",
  SET_PAYMENT_WITHDRAW_LAST: "payment_withdraw/SET_PAYMENT_WITHDRAW_LAST",
  //
};
